var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "card" }, [
      _c("div", { staticClass: "cover-img-top  shadow" }, [
        _c("img", {
          staticClass: "card-img-top img-fluid cover-img-top",
          attrs: {
            src:
              _vm.group.group_cover == null
                ? "/images/cover.png"
                : _vm.group.group_cover.url,
            alt: "Group Cover",
          },
        }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "card-content" }, [
        _c("div", { staticClass: "card-header" }, [
          _c("div", { staticClass: "col-12 pl-0 pr-0" }, [
            _c("h1", { staticClass: "pb-0 mb-0 font-large-2" }, [
              _vm._v(_vm._s(_vm.group.title)),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "card-body row pb-0" }, [
          _c("div", { staticClass: "col-12 col-md-4 mb-1" }, [
            _c(
              "div",
              { staticClass: "d-inline-block text-dark font-medium-3" },
              [
                _vm.group.group_privacy == "1"
                  ? _c(
                      "span",
                      { staticClass: "badge badge-pill badge-light pr-1" },
                      [
                        _c("i", {
                          staticClass: "fa fa-shield-alt mr-05",
                          attrs: {
                            "data-toggle": "tooltip",
                            "data-placement": "bottom",
                            title: "Private Group",
                          },
                        }),
                        _vm._v(" Private\n                            "),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "badge badge-pill " }, [
                  _c("i", { staticClass: "fa fa-users mr-05" }),
                  _vm._v(
                    " " +
                      _vm._s(_vm.group.total_members) +
                      " " +
                      _vm._s(_vm.__("group.title_members")) +
                      "\n                            "
                  ),
                ]),
              ]
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "col-12 col-sm-8 col-md-8 col-lg-8 float-right text-right pr-05 pl-05 pb-1",
            },
            [
              _c("div", { staticClass: "d-flex justify-content-around" }, [
                _c(
                  "button",
                  {
                    staticClass:
                      "btn btn-primary waves-effect waves-light mr-05 profile-menu",
                    attrs: {
                      href: "#",
                      "data-toggle": "modal",
                      "data-target": "#registerModal",
                    },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        _vm.active_tab = null
                      },
                    },
                  },
                  [
                    _c("i", { staticClass: "feather icon-send mobile-hide" }),
                    _vm._v(
                      " " +
                        _vm._s(_vm.__("group.form.links.posts")) +
                        "\n                            "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass:
                      "btn btn-primary waves-effect waves-light  mr-05 profile-menu",
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        _vm.active_tab = "events"
                        _vm.loadEvents()
                      },
                    },
                  },
                  [
                    _c("i", {
                      staticClass: "feather icon-calendar mobile-hide",
                    }),
                    _vm._v(
                      " " +
                        _vm._s(_vm.__("group.form.links.events")) +
                        "\n                            "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass:
                      "btn btn-primary waves-effect waves-light  mr-05 profile-menu",
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        _vm.active_tab = "products"
                        _vm.loadProducts()
                      },
                    },
                  },
                  [
                    _c("i", {
                      staticClass: "feather icon-shopping-cart mobile-hide",
                    }),
                    _vm._v(
                      " " +
                        _vm._s(_vm.__("group.form.links.products")) +
                        "\n                            "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass:
                      "btn btn-primary waves-effect waves-light  mr-05 profile-menu",
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        _vm.active_tab = "resources"
                        _vm.loadResources()
                      },
                    },
                  },
                  [
                    _c("i", {
                      staticClass: "feather icon-shopping-cart mobile-hide",
                    }),
                    _vm._v(
                      " " +
                        _vm._s(_vm.__("group.form.links.resources")) +
                        "\n                            "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass:
                      "btn btn-primary waves-effect waves-light  mr-05 profile-menu",
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        _vm.active_tab = "videos"
                        _vm.loadVideos()
                      },
                    },
                  },
                  [
                    _c("i", { staticClass: "feather icon-video mobile-hide" }),
                    _vm._v(
                      " " +
                        _vm._s(_vm.__("group.form.links.videos")) +
                        "\n                            "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass:
                      "btn btn-primary waves-effect waves-light profile-menu",
                    attrs: {
                      href: "#",
                      "data-toggle": "modal",
                      "data-target": "#registerModal",
                    },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        _vm.active_tab = null
                      },
                    },
                  },
                  [
                    _c("i", { staticClass: "feather icon-user mobile-hide" }),
                    _vm._v(
                      " " +
                        _vm._s(_vm.__("group.title_members")) +
                        "\n                            "
                    ),
                  ]
                ),
              ]),
            ]
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-12 col-md-12" }, [
        _c("div", { staticClass: "card p-1" }, [
          _c("div", { staticClass: "card-title" }, [
            _c("h4", { staticClass: "mb-1 pb-05 border-bottom" }, [
              _c("i", { staticClass: "feather icon-users" }),
              _vm._v(" " + _vm._s(_vm.group.title)),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "card-body p-0" }, [
            _c("span", {
              staticClass: "breakAll image-resize",
              domProps: { innerHTML: _vm._s(_vm.group.group_description) },
            }),
          ]),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _vm.isLoading
      ? _c(
          "div",
          [
            _c("infinite-loading", [
              _c("div", { attrs: { slot: "no-more" }, slot: "no-more" }),
              _vm._v(" "),
              _c("div", { attrs: { slot: "no-results" }, slot: "no-results" }),
            ]),
          ],
          1
        )
      : _c("div", [
          this.active_tab === "events" && _vm.events.length > 0
            ? _c(
                "div",
                { staticClass: "row p-05" },
                _vm._l(_vm.events, function (event, index) {
                  return _c("guest-event-card", {
                    key: index,
                    attrs: {
                      event: event,
                      service_settings: _vm.service_settings.event,
                    },
                  })
                }),
                1
              )
            : this.active_tab === "products" && _vm.products.length > 0
            ? _c(
                "div",
                { staticClass: "row p-05" },
                _vm._l(_vm.products, function (product, index) {
                  return _c("guest-product-card", {
                    key: index,
                    attrs: {
                      product: product,
                      service_settings: _vm.service_settings.product,
                    },
                  })
                }),
                1
              )
            : this.active_tab === "resources" && _vm.resources.length > 0
            ? _c(
                "div",
                { staticClass: "row p-05" },
                _vm._l(_vm.resources, function (resource, index) {
                  return _c("guest-resource-card", {
                    key: index,
                    attrs: {
                      resource: resource,
                      service_settings: _vm.service_settings.resource,
                    },
                  })
                }),
                1
              )
            : this.active_tab === "videos" && _vm.videos.length > 0
            ? _c(
                "div",
                { staticClass: "row p-05" },
                _vm._l(_vm.videos, function (video, index) {
                  return _c("guest-video-card", {
                    key: index,
                    attrs: {
                      video: video,
                      service_settings: _vm.service_settings.video,
                    },
                  })
                }),
                1
              )
            : _vm._e(),
        ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }